import { Trash2 } from 'lucide-react'
import { StatusBadge } from '../StatusBadge/index'
import type { ProjectStatus } from '../StatusBadge/index'
import styles from './ProjectCard.module.css'

export interface ProjectCardProject {
  id: string
  name: string | null | undefined
  status: string | null | undefined
  created_at: string | null | undefined
  file_count: number | null | undefined
}

export interface ProjectCardProps {
  project: ProjectCardProject
  onClick: () => void
  onDelete: () => void
}

function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '—'
  const d = new Date(dateStr)
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('de-AT', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function ProjectCard({ project, onClick, onDelete }: ProjectCardProps) {
  const name = project.name ?? '(Ohne Titel)'
  const status = (project.status ?? 'uploaded') as ProjectStatus
  const fileCount = project.file_count ?? 0

  return (
    <div className={styles.card} onClick={onClick} role="button" tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClick() }}>
      <div className={styles.info}>
        <div className={styles.name}>{name}</div>
        <div className={styles.meta}>
          <StatusBadge status={status} />
          <span className={styles.metaText}>
            {fileCount} {fileCount === 1 ? 'Datei' : 'Dateien'}
          </span>
          <span className={styles.metaText}>{formatDate(project.created_at)}</span>
        </div>
      </div>
      <button
        className={styles.deleteBtn}
        onClick={(e) => { e.stopPropagation(); onDelete() }}
        aria-label="Projekt löschen"
        title="Projekt löschen"
      >
        <Trash2 size={16} />
      </button>
    </div>
  )
}
